import formsService from '../../components/consentForms/ConsentFormsService.js'


const state = {
  form: {
    formTitle: '',
    formQuestion: '',
    formConsents: [],
    createdDate: '',
    expirationDate: ''
  },
  forms: [],
}

const getters = {
  form: state => {
    return state.form
  },
  forms: state => {
    return state.forms
  },
}

const mutations = {
  'SET_FORM': (state, form) => {
    state.form = form
  },

  "SET_FORM_QUESTION": (state, question) => {
    state.form.formQuestion = question
  },

  'SET_FORM_ARRAY': (state, forms) => {
    state.forms = forms
  },

  'SET_FORM_CONSENTS': (state, consents) => {
    state.form.formConsents = consents;
  },

  'ADD_CONSENT_TO_FORM': (state, consent) => {
    state.form.formConsents.push(consent);
  },

  "REMOVE_CONSENT_FROM_FORM": (state, idx) => {
    state.form.formConsents.splice(idx, 1);
  },

  'REMOVE_FORM': (state, idx) => {
    state.forms.splice(idx, 1);
  },

  'ADD_FROM': (state, form) => {
    state.forms.add(form)
  }
}

const actions = {
  fetchForms: ({
    commit
  }) => {
    formsService.fetchForms().then(result => {
      let data = result.data

      const forms = data.displayFormDTOList

      commit('SET_FORM_ARRAY', forms)
    })
  },

  fetchOne: ({
    commit
  }, id) => {
    formsService.fetchOne(id).then(result => {
      let form = result.data
      commit('SET_FORM', form)
    })
  },

  searchForms: ({
    commit
  }, criteria) => {
    formsService.filterForms(criteria).then(result => {

      let forms = result.data.dateInfoFormDTOS;
      commit('SET_FORM_ARRAY', forms)
    })

  },

  fetchFormInfo: ({
    commit
  }, formId) => {
    formsService.fetchFormInfo(formId).then(result => {

      data = result.data;

      commit('SET_FORM_QUESTION', data.formQuestion);
      commit('SET_FORM_CONSENTS', data.formConsents);

    })
  },

  editForm: ({
    commit
  }, form) => {
    formsService.updateForm(form).then(res => {
      this.$toasted.success("Form Edited Succesfully", {
        icon: "fa-check",
        position: "top-right",
        duration: 2000,
        fullWidth: false

      })


    }).catch(error => {
      const message =
        error.response.data.message == undefined ?
        "Something went wrong" :
        error.response.data.message;

      this.$toasted.error(message, {
        icon: "fa-close",
        position: "top-right",
        duration: 2000,
        fullWidth: false
      });
    })
  },

  formAddConsent: ({
    commit
  }, consent) => {
    commit('ADD_CONSENT_TO_FORM', consent);
  },

  formRemoveConsent: ({
    commit
  }, idx) => {
    commit("REMOVE_CONSENT_FROM_FORM", idx);
  },

  addForm: ({
    commit
  }, form) => {
    commit('ADD_FORM', form);
  },

  removeForm: ({
    commit
  }, idx) => {
    commit('REMOVE_FORM', idx);
  },

  saveForm: ({
    commit
  }, form) => {
    formsService.createForm(form).then(rest => {
      this.$toasted.success("Form Created Succesfully", {
        icon: "fa-check",
        position: "top-right",
        duration: 2000,
        fullWidth: false
      })
    }).catch(error => {
      const message =
        error.response.data.message == undefined ?
        "Something went wrong" :
        error.response.data.message;

      this.$toasted.error(message, {
        icon: "fa-close",
        position: "top-right",
        duration: 2000,
        fullWidth: false
      });
    });
  },

  clearForms: ({
    commit
  }) => {
    commit('SET_FORM_ARRAY', [])
  },

  //Assign one form
  setForm: ({
    commit
  }, form) => {
    commit('SET_FORM', form)
  },

  //Set Form's question 
  setFormQuestion: ({
    commit
  }, formQuestion) => {
    commit('SET_FORM_QUESTION', formQuestion)
  },


  setFormConsents: ({
    commit
  }, consents) => {
    commit('SET_FORM_CONSENTS', consents)
  },

  //Creates a list of forms
  setFormArray: ({
    commit
  }, forms) => {
    commit('SET_FORM_ARRAY', forms)
  }

}

export default {
  state,
  getters,
  mutations,
  actions,
}
